import { useCallback } from 'react';
import { Box, CircularProgress, Table, TableBody, TableContainer, TableRow } from '@mui/material';
import { StyledTableCellEmptyMessage } from 'dashboard409a/components/ValuationsTable/common';
import { modelsColumns } from 'dashboard409a/pages/Workboard/common/modelsColConfig';
import { ModelsStatusOption, ModelsTableHeadColumn, ModelsTableProps } from './ModelsTable.types';
import ModelsTableHead from './ModelsTableHead/ModelsTableHead';
import ModelsTableRow from './ModelsTableRow/ModelsTableRow';
import { ModelWithValuationData } from '../../services/models.types';

export const ModelsTable = ({
  isLoading,
  rows,
  onNoteSave,
  onStatusUpdate,
  orderBy,
  order,
  onRequestSort,
  isNoteLoading = false,
  noteError = null,
  onRowClick,
}: ModelsTableProps) => {
  const statusOptions: ModelsStatusOption[] = [];
  const statusOptionsLoading = false;

  const createNoteSaveHandler = useCallback(
    (row: ModelWithValuationData) => (noteContent: string, currentNote?: string) => {
      if (!row.id) {
        return Promise.reject(new Error('Fulfillment ID is missing'));
      }
      // Pass the note content from the new structure or fallback to old structure
      const currentNoteContent = row.note?.content || row.notes || '';
      return onNoteSave(row.id, noteContent, currentNote || currentNoteContent);
    },
    [onNoteSave]
  );

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <TableContainer>
        <Table>
          <ModelsTableHead
            orderBy={orderBy}
            order={order}
            onRequestSort={onRequestSort}
            columns={modelsColumns as ModelsTableHeadColumn[]}
          />
          <TableBody>
            {rows.length === 0 ? (
              <TableRow style={{ height: 33 }}>
                <StyledTableCellEmptyMessage colSpan={8}>No models found</StyledTableCellEmptyMessage>
              </TableRow>
            ) : (
              rows.map(row => (
                <ModelsTableRow
                  key={row.id}
                  modelRow={row}
                  onRowClick={onRowClick}
                  statusOptions={statusOptions}
                  statusOptionsLoading={statusOptionsLoading}
                  onNoteSave={createNoteSaveHandler(row)}
                  onStatusUpdate={onStatusUpdate}
                  isNoteLoading={isNoteLoading}
                  noteError={noteError}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};